export default __webpack_public_path__ + "static/media/cabin-deck-mobile.ba2fdada.png";